module.exports = __webpack_public_path__ + "img/emoji_55.654f7bdd.png";